import _get from 'lodash/get';
import { BackgroundJob } from 'graphql-common';
import downloadHandler from '@lib/utils/downloadHandler';

const DOWNLOADED_JOBS_KEY = 'JOB_TRACKER_DOWNLOADED';

const getDownloadedIds = (): string[] => {
  try {
    const raw = localStorage.getItem(DOWNLOADED_JOBS_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const markDownloaded = (id: string) => {
  try {
    const ids = getDownloadedIds();
    if (!ids.includes(id)) {
      // Cap the list so it can't grow unbounded across sessions.
      const next = [...ids, id].slice(-200);
      localStorage.setItem(DOWNLOADED_JOBS_KEY, JSON.stringify(next));
    }
  } catch {
    // ignore storage failures — at worst the file downloads twice
  }
};

// Auto-download a completed result-bearing job (QR codes / timeline report)
// exactly once. The "already downloaded" flag is kept in localStorage so a job
// that completes while the tab is reloading isn't re-downloaded on the next
// seed query.
const handleJobCompletion = (job: BackgroundJob) => {
  const downloadLink = _get(job, 'result.link') as string | undefined;
  if (!downloadLink) return;
  const downloadedIds = getDownloadedIds();
  if (downloadedIds.includes(job.id)) return;
  downloadHandler(downloadLink);
  markDownloaded(job.id);
};

export default handleJobCompletion;
